import { useUpgradeContext } from "@zenith/context";
import { TierStepsResponseDTO } from "@zenith/services/user";

import useAppStepper from "./appStepper";

// Steps the user has nothing left to do on during this upgrade.
const DONE_STATUSES: ReadonlyArray<
  TierStepsResponseDTO.stepStatus | undefined
> = [
  TierStepsResponseDTO.stepStatus.APPROVED,
  TierStepsResponseDTO.stepStatus.PENDING,
];

/**
 * Tier upgrade stepper. Continue moves to the next step that still needs the
 * user - approved or pending steps are skipped - so resubmitting a rejected
 * step doesn't walk back through empty forms for steps already done. Past the
 * last step, TiersLayout opens the End Upgrade page.
 */
const useTierStepper = () => {
  const { activeStep, setActiveStep } = useAppStepper();
  const {
    upgradeContext: { tierSteps },
  } = useUpgradeContext();

  const goToNextOpenStep = (): void => {
    const steps = tierSteps ?? [];
    let next = activeStep + 1;
    while (
      next < steps.length &&
      DONE_STATUSES.includes(steps[next].stepStatus)
    ) {
      next += 1;
    }
    setActiveStep(next);
  };

  return { goToNextOpenStep };
};

export default useTierStepper;
